import React from "react";
import "./terms-conditions.css";

const PrivacyPolicy = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Grievance Redressal</h1>
      </header>

      <section className="tc-content mb-3">
      
        <h2>Introduction</h2>
    <p>At Loanontip, customer satisfaction and transparency form the foundation of our operations. We believe that a responsive and fair grievance redressal mechanism is essential for maintaining customer trust and ensuring responsible lending practices.</p>

    <p>This Grievance Redressal Policy outlines the process for handling customer concerns in a prompt, efficient, and courteous manner, in line with the directives of the Reserve Bank of India (RBI) and good industry practices.</p>

        <h2>Purpose</h2>
        <p>Customer complaints provide valuable insights into areas of improvement. This policy aims to:</p> 

            <li>Ensure that customer grievances are resolved quickly and fairly.</li>
            <li>Create a structured system for registering, tracking, and resolving complaints.</li>
            <li>Minimize recurrence of similar issues through periodic review and monitoring.</li>
            <li>Strengthen customer confidence by maintaining transparency and accountability.</li>
        

        <h2>Guiding Principles</h2>
        <p>The grievance redressal framework of Loanontip is built on the following principles:</p> 

            <li>Customers are treated fairly, courteously, and without bias.</li>
            <li>Complaints are acknowledged and resolved within defined timelines.</li>
            <li>Customers are informed about the process of escalation in case they are unsatisfied with the initial response.</li>
            <li>All employees work in good faith and uphold the interests of the customers at all times.</li>
        

        <h2>Internal Mechanism for Handling Customer Complaints</h2>
        <p>Loanontip has implemented a robust Customer Relationship Management (CRM) system to record, monitor, and resolve customer grievances efficiently.</p> 

            <li>Each complaint received is assigned a unique reference number and tracked until resolution.</li>
            <li>Complaints are categorized based on their nature (technical, financial, operational, etc.) and prioritized according to impact.</li>
            <li>Every attempt is made to resolve customer complaints within fourteen (14) working days from the date of receipt.</li>
            <li>Customers are notified of the progress or any expected delay in resolution.</li>
        <p>If a customer is not satisfied with the resolution provided by the Customer Care team, they can escalate the concern as per the escalation matrix below.</p>

        <h2>Time Frame for Resolution</h2>
        <p>The standard timeline for addressing customer grievances is within fourteen (14) working days from the date of registration of the complaint.
In cases requiring detailed investigation, the customer will be informed of the reason for delay and the expected resolution timeline.
</p>

        <h2>Review and Monitoring</h2>
        <p>All grievances are periodically reviewed by the Grievance Redressal Committee to:</p> 

            <li>Identify process gaps and recurring issues.</li>
            <li>Improve service quality and customer experience.</li>
            <li>Ensure adherence to timelines and fairness in resolution.</li> <br />
        <p>Quarterly reports on grievances received and resolved are submitted for internal compliance review.</p>

        <h2>Touchpoints for Raising a Complaint</h2>
        <p>Customers may raise concerns related to:</p> 

            <li>Loan application or approval process</li>
            <li>EMI schedule or repayment issues</li>
            <li>Interest rate or processing fee discrepancies</li>
            <li>Technical or service-related issues with the Loanontip platform</li>
            <li>Any other service-related matter</li> <br />
        <p>Customers can contact Loanontip via the following channels:</p>

<p><b>Email: </b> support@loanontip.in</p>
<p><b>Website: </b>www.loanontip.in</p>
<p><b>Customer Support: </b> +91-XXXXXXXXXX</p>
<p><b>Working Hours: </b> Monday to Saturday, 10:00 AM – 7:00 PM (excluding public holidays)</p>

<h2>Grievance Redressal Officer (GRO)</h2>
        <p>If the customer is not satisfied with the initial resolution provided by the customer support team, the matter may be escalated to the Grievance Redressal Officer.</p> 
        <p><b>Grievance Redressal Officer:</b></p>

            <b>Name:</b> [To be Updated – Authorized Representative]
            <b>Designation:</b> Grievance Redressal Officer
            <b>Company:</b> RRYO Private Limited (Operator of Loanontip)
            <b>Address:</b> [Registered Office Address of RRYO Private Limited]
            <b>Email:</b>grievance@loanontip.in
            <b>Contact No:</b>+91-XXXXXXXXXX

        <p>The Grievance Redressal Officer shall make every effort to resolve the grievance within fourteen (14) working days from the date of receipt.</p>

<p><b>Email: </b> support@loanontip.in</p>
<p><b>Website: </b>www.loanontip.in</p>
<p><b>Customer Support: </b> +91-XXXXXXXXXX</p>
<p><b>Working Hours: </b> Monday to Saturday, 10:00 AM – 7:00 PM (excluding public holidays)</p>
        
        <h2>2. Grievance Redressal Officer</h2>
        <p>Borrowers are requested to address all grievances at the first instance to the Grievance Redressal Officer (GRO).</p>

        <p><b>Name: <br />
        Designation: <br />
        Company: RRYO Private Limited (Loanontip) <br />
        Address: <br />
        Contact Number: <br />
        Email <br />
          </b></p>

          <p>The Grievance Redressal Officer may be reached on the contact details provided above between 10:00 AM to 9:00 PM (Monday to Friday) and 10:00 AM to 7:00 PM (Saturday), excluding public holidays.
All complaints will be acknowledged and resolved within fourteen (14) working days from the date of receipt.
</p>
      
        <h2>Further Escalation (RBI Ombudsman)</h2>
        <p>If the customer does not receive a satisfactory response from Loanontip within 30 days, they may approach the Reserve Bank – Integrated Ombudsman Scheme, 2021 (RB-IOS).</p>

        
        <p>For details, customers can visit: <br />
        https://cms.rbi.org.in</p>

        <h2>Policy Review</h2>

        <p>This policy will be reviewed periodically (at least once annually) to ensure compliance with applicable laws, RBI circulars, and evolving customer service standards.</p>

          <h2>Disclaimer</h2>

        <p>Loanontip is a digital lending platform owned and managed by RRYO Private Limited.
All loans offered through the platform are sanctioned and disbursed by ACG Leasing Limited, an RBI-registered NBFC.
Loanontip itself does not lend or determine loan terms.
</p>
       
      </section>
    </div>
  );
};

export default PrivacyPolicy;
